/**
 * Paths for scanner instruments.
 * - proxy: used with base BASE_URL/api-next/ → /api-next/scanner, rewrite → /api/scanner
 * - upstream: full URL per source (server-side)
 */
export const scannerRoutes = {
  instruments: { proxy: 'scanner' },
} as const;
